// extracted by mini-css-extract-plugin
module.exports = {"content":"notfound_content__A88HH","notfound":"notfound_notfound__xVkPn","code":"notfound_code__vs5ym","text":"notfound_text__og1y9","boto":"notfound_boto__mXM6S"};